export default "__VITE_ASSET__CD_bcz5P__"